<template>
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M21.333 3.694h.334v1.973H24V9h-2.333v2.667H10.333l-.75 3h1.75V13h2v5.333h-2v-1.666h-2.25L8 21H1.333l2.338-9.346A4 4 0 0 1 0 7.667C0 5.683 1.442 4.01 3.333 3.694z"/></svg>
</template>